import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { formatPagerStateView, isFirstPage, isLastPage } from "../utils";

interface IItemPagerProps {
    currentIndex: number;
    totalCount: number;
    onPrevious: VoidFunction;
    onNext: VoidFunction;
    previousLabel: string;
    nextLabel: string;
}

const ItemPager = ({ currentIndex, totalCount, onPrevious, onNext, previousLabel, nextLabel }: IItemPagerProps) => {
    return (
        <Flex
            gap="8px"
            alignItems="center"
            data-automation="item-pager"
        >
            <IconButton
                dataAutomation="item-pager-prev"
                aria-label={previousLabel}
                type="flat"
                iconName="arrow-left"
                iconSize="xs"
                isDisabled={isFirstPage(currentIndex)}
                onClick={onPrevious}
            />

            <Text
                fontVariant="caption"
                color={colorsPalettes.carbon[400]}
                textAlign="center"
                whiteSpace="nowrap"
            >
                {formatPagerStateView(currentIndex, totalCount)}
            </Text>

            <IconButton
                dataAutomation="item-pager-next"
                aria-label={nextLabel}
                type="flat"
                iconName="arrow-right"
                iconSize="xs"
                isDisabled={isLastPage(currentIndex, totalCount)}
                onClick={onNext}
            />
        </Flex>
    );
};

export default ItemPager;
